<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <v-card class="mx-auto" max-width="600px">
            <v-toolbar color="secondary" dark>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <Medication />
            </v-toolbar>
            <MedicationsView />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import MedicationsView from "@/components/views/MedicationsView";
import Medication from "@/components/dialogs/Medication";

export default {
  name: "Medications",
  components: {
    MedicationsView,
    Medication
  },
  events: {
    callToggle() {
      this.toggleComp();
    }
  },
  data: () => ({
    dialog: false,
    valid: true,
    title: "Your Medications",
    btnTitle: "Add new"
  }),
  
};
</script>

<style>
</style>